export const SequenceSmsIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M13.333 2H2.667A1.333 1.333 0 0 0 1.333 3.333v10L4 10.667h9.333a1.333 1.333 0 0 0 1.334-1.334V3.333A1.333 1.333 0 0 0 13.333 2Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SequenceEmailIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <rect
      x="1.333"
      y="3.333"
      width="13.333"
      height="9.333"
      rx="1.333"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="m1.333 4.667 5.94 3.96a1.333 1.333 0 0 0 1.454 0l5.94-3.96"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SequenceTogetherIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M1.667 5.333h10L9 2.667M14.333 10.667h-10L7 13.333"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SequenceFallbackIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M8 14V8m0 0L3.333 2.667M8 8l4.667-5.333"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="3" cy="2.333" r="1.333" fill="currentColor" />
    <circle cx="13" cy="2.333" r="1.333" fill="currentColor" />
  </svg>
)

export const SequenceStartIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
    <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.4" />
    <path d="M8.25 6.75 13 10l-4.75 3.25v-6.5Z" fill="currentColor" />
  </svg>
)

export const SequenceEndIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M3.333 14V2.667h6l.667 1.333h3.333v6h-4l-.666-1.333h-5.334"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SequenceTimerIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <circle cx="8" cy="9" r="5.667" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M8 6.333V9l1.667 1.667M6 1.333h4"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SequenceReadyIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="m3 8.5 3.2 3.2L13 4.9"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SequenceWarningIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M8 2.5 1.5 13.5h13L8 2.5Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M8 6.667v3M8 11.833h.007"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
)

export const SequencePencilIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M11.333 2.667a1.414 1.414 0 1 1 2 2L5.333 12.667l-2.666.666.666-2.666 8-8Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SequenceTrashIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M2.667 4.667h10.666M6.667 7.333v4M9.333 7.333v4M3.333 4.667 4 13.333h8l.667-8.666M6 4.667V2.667h4v2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SequencePlusIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M8 3.333v9.334M3.333 8h9.334"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
)

export const SequenceCloseIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M12 4 4 12M4 4l8 8"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
)

export const SequenceSaveIcon = props => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M2 3.333c0-.736.597-1.333 1.333-1.333h7.505c.354 0 .693.14.943.39l1.829 1.829c.25.25.39.589.39.943v7.505c0 .736-.597 1.333-1.333 1.333H3.333A1.333 1.333 0 0 1 2 12.667V3.333Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M4.667 2v3.333h6V2M4.667 14v-3.333h6V14"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
)
